
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from 'src/app/modules/core/core.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { RetailerModule } from 'src/app/modules/retailer/retailer.module';
import { CpgModule } from 'src/app/modules/cpg/cpg.module';
import { DistributorModule } from './modules/distributor/distributor.module';
import { AdminModule } from 'src/app/modules/admin/admin.module';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    RetailerModule,
    CpgModule,
    DistributorModule,
    AdminModule,
    AppRoutingModule, // (THIS SHOULD BE LAST)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
